
export class MessageBusResponse
{
    public IsSuccess: boolean = false;
    public ErrorMessage: string = "";
    public ErrorCode: number = (-1);
    public Result?: any = undefined;

    public static Success(result?: any): MessageBusResponse
    {
        const response = new MessageBusResponse();
        response.IsSuccess = true;
        response.Result = result;
        return response;
    }

    public static Fault(errorCode: number, errorMessage: string): MessageBusResponse
    {
        const response = new MessageBusResponse();
        response.IsSuccess = false;
        response.Result = undefined;
        response.ErrorCode = errorCode;
        response.ErrorMessage = errorMessage;
        return response;
    }
}
